import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInStockItems,
} from "./thunk";

interface InStockItemsState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: InStockItemsState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const inStockItemsSlice = createSlice({
  name: "inStockItems",
  initialState,
  reducers: {
    clearInStockItems: (state) => {
      state.list = [];
      state.rowCount = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch In Stock Items
      .addCase(fetchInStockItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInStockItems.fulfilled, (state, action) => {
        state.loading = false;
        const normalizedList = Array.isArray(action.payload?.data)
          ? action.payload.data
          : action.payload?.data
            ? [action.payload.data]
            : [];
        state.list = normalizedList;
        state.rowCount = action.payload?.rowCount || normalizedList.length;
        state.error = null;
      })
      .addCase(fetchInStockItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch in stock items";
      });
  },
});

export const { clearInStockItems } = inStockItemsSlice.actions;
export default inStockItemsSlice.reducer;
